<template>
  <div class="relative flex flex-wrap items-center w-full lg:w-3/4 xl:w-3/5">
    <section class="w-full lg:w-1/2 bg-gradient p-12 lg:p-20 lg:mr-4">
      <div class="h2 text-white mb-6">
        Schrijf je in voor de nieuwsbrief!
      </div>
      <div class="text-white text-sm">
        Wil jij op de hoogte blijven van het laatste nieuws over Mijn Superkracht? Schrijf je dan nu in voor onze nieuwsbrief!
      </div>
    </section>

    <form class="w-full md:w-1/2 lg:w-1/3 px-12 lg:px-0 pt-6 lg:pt-0">
      <text-field id="name" required placeholder="Naam">
        Naam
      </text-field>
      <text-field id="email" required type="email" placeholder="E-mailadres">
        E-mailadres
      </text-field>
      <button class="btn btn-secondary w-full">
        Inschrijven voor nieuwsbrief
      </button>
    </form>

    <div class="absolute hidden md:block right-0 bottom-0 mr-32 lg:-mr-16 xl:-mr-20" style="height: 270px;">
      <img src="~/assets/img/characters/character-front.svg" alt="" aria-hidden="true" class="h-full">
    </div>
  </div>
</template>

<script>
import TextField from '~/components/forms/TextField';

export default {
  name: 'NewsletterSubscribe',
  components: {TextField},
};
</script>
